import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AzureIntegrationView } from "../../../useSearchCloudIntegrations/gql";

const IntegrationsAzureTableNameCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AzureIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./${item.id}`}>{item.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationsAzureTableNameCell;
